<template>



    <p class="text-headline-small mb-4">Identificazione</p>

    <v-text-field label="Codice" v-model="properties.codice"
    @update:model-value="setLabel"
    >
        <template v-slot:append>
            <v-btn size="" color="primary" @click="copy2clipboard(properties.codice)" class="pa-4"
            :disabled="!properties.codice"
            >
                <v-icon>mdi-content-copy</v-icon>
            </v-btn>
        </template>
    </v-text-field>
    <SegnalazioneCommon v-model="properties" />


</template>

<script setup>

import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import { onMounted } from 'vue'
// import { useToastsStore } from "@/store/toasts";
import { useCopyToClipboard } from "@/service/copyToClipboard";

const properties = defineModel()
// const toastsStore = useToastsStore();
const {copy2clipboard}  = useCopyToClipboard();


// eslint-disable-next-line no-unused-vars
const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  }
})


const setLabel = () => {
  if (properties.value.codice) {
    properties.value.label = `Veicolo: ${properties.value.codice}`
  }
  else {
    properties.value.label = "Veicolo"
  }
}

onMounted(() => {
  setLabel()
})



</script>
